//export const NextIconDisabled = "https://members.performancegolf.com/wp-content/uploads/2024/05/NextIconDisabled.svg";
export const NextIconDisabled = "/wp-content/themes/pgm/dist/images/icons/NextIconDisabled.svg";
//export const NextIconEnabled = "https://members.performancegolf.com/wp-content/uploads/2024/05/NextIconEnabled.svg";
export const NextIconEnabled = "/wp-content/themes/pgm/dist/images/icons/NextIconEnabled.svg";
//export const PrevIconDisabled = "https://members.performancegolf.com/wp-content/uploads/2024/05/prevIconDisabled.svg";
export const PrevIconDisabled = "/wp-content/themes/pgm/dist/images/icons/PrevIconDisabled.svg";
//export const PrevIconEnabled = "https://members.performancegolf.com/wp-content/uploads/2024/05/PrevIconEnabled.svg";
export const PrevIconEnabled = "/wp-content/themes/pgm/dist/images/icons/PrevIconEnabled.svg";

export function calculateCardsPerPage(parentPage: string, isSidebarOpen: boolean) {
  // Calculate the number of cards per page based on the width of the screen
  let screenWidth = window.innerWidth;
  if (screenWidth >= 900 && parentPage === "course-footer") {
    screenWidth *= 9/12;
  }
  if (parentPage === "dash") {
    if (screenWidth >= 768 && screenWidth < 840) {
      return 4;
    } else if (screenWidth >= 840 && screenWidth < 900) {
      return 4;
    } else if (screenWidth >= 900 && screenWidth < 980) {
      return 3;
    } else if (screenWidth >= 980 && screenWidth < 1024) {
      return 3;
    } else if (screenWidth >= 1024 && screenWidth < 1280) {
      return 3;
    } else if (screenWidth >= 1280) {
      return 4;
    } else {
      return screenWidth / 210;
    }
  } else if(parentPage === "course-player") {
    if (screenWidth >= 1440) {
      return 5;
    } else {
      return 4;
    }
  } else {
    if (isSidebarOpen) {
      if (screenWidth >= 768 && screenWidth < 840) {
        return 2;
      } else if (screenWidth >= 840 && screenWidth < 900) {
        return 3;
      } else if (screenWidth >= 900 && screenWidth < 1024) {
        return 3;
      } else if (screenWidth >= 1024 && screenWidth < 1280) {
        return 3;
      } else if (screenWidth >= 1280 && screenWidth < 1440) {
        return 5;
      } else if (screenWidth >= 1440) {
        return 5;
      } else {
        return screenWidth / 210;
      }
    } else {
      if (screenWidth >= 670 && screenWidth < 840) {
        return 4;
      } else if (screenWidth >= 840 && screenWidth < 900) {
        return 4;
      } else if (screenWidth >= 900 && screenWidth < 1024) {
        return 5;
      } else if (screenWidth >= 1024 && screenWidth < 1280) {
        return 5;
      } else if (screenWidth >= 1280 && screenWidth < 1440) {
        return 6;
      } else if (screenWidth >= 1440) {
        if (parentPage === "course-footer") {
          if(screenWidth >= 2500) return 12;
          if(screenWidth >= 1750) return 9;
        }
        return 7;
      } else {
        return screenWidth / 210;
      }
    }
  }
}

export const calculateCarouselLeftOffset = (
  isMobile: boolean,
  parentPage: string,
  isSidebarOpen: boolean,
  setCarouselLeftOffset: (offset: number) => void
) => {
  let screenWidth = window.innerWidth;
  if (!isMobile) {
    if (parentPage === "dash") {
      if (screenWidth > 767 && screenWidth < 840) {
        setCarouselLeftOffset(-94);
      } else if (screenWidth > 839 && screenWidth < 900) {
        setCarouselLeftOffset(-24);
      } else if (screenWidth > 899 && screenWidth < 980) {
        setCarouselLeftOffset(-60);
      } else if (screenWidth > 979 && screenWidth < 1024) {
        setCarouselLeftOffset(-16);
      } else if (screenWidth > 1023 && screenWidth < 1280) {
        setCarouselLeftOffset(-55);
      } else if (screenWidth > 1279 && screenWidth < 1440) {
        setCarouselLeftOffset(0);
      } else if (screenWidth > 1439) {
        setCarouselLeftOffset(0);
      }
    } else if (parentPage === "course" || parentPage === "course-footer") {
      if (isSidebarOpen) {
        if (screenWidth > 767 && screenWidth < 840) {
          setCarouselLeftOffset(-30);
        } else if (screenWidth > 839 && screenWidth < 900) {
          setCarouselLeftOffset(-176);
        } else if (screenWidth > 899 && screenWidth < 980) {
          setCarouselLeftOffset(-100);
        } else if (screenWidth > 979 && screenWidth < 1024) {
          setCarouselLeftOffset(-21);
        } else if (screenWidth > 1023 && screenWidth < 1280) {
          setCarouselLeftOffset(-27);
        } else if (screenWidth > 1279 && screenWidth < 1440) {
          setCarouselLeftOffset(-205);
        } else if (screenWidth > 1439) {
          setCarouselLeftOffset(-41);
        }
      } else {
        if (screenWidth > 767 && screenWidth < 840) {
          setCarouselLeftOffset(-121);
        } else if (screenWidth > 839 && screenWidth < 900) {
          setCarouselLeftOffset(-30);
        } else if (screenWidth > 899 && screenWidth < 980) {
          setCarouselLeftOffset(-210);
        } else if (screenWidth > 979 && screenWidth < 1024) {
          setCarouselLeftOffset(-105);
        } else if (screenWidth > 1023 && screenWidth < 1280) {
          setCarouselLeftOffset(-94);
        } else if (screenWidth > 1279 && screenWidth < 1440) {
          setCarouselLeftOffset(-56);
        } else if (screenWidth > 1439) {
          setCarouselLeftOffset(-106);
        }
      }
    }
  }
};

export const replaceCarouselOffset = (realOffset: number): number => {
  if (realOffset === -30) {
    return -121;
  } else if (realOffset === -176) {
    return -30;
  } else if (realOffset === -100) {
    return -210;
  } else if (realOffset === -21) {
    return -105;
  } else if (realOffset === -27) {
    return -94;
  } else if (realOffset === -205) {
    return -56;
  } else if (realOffset === -41) {
    return -106;
  } else if (realOffset === -121) {
    return -30;
  } else if (realOffset === -30) {
    return -176;
  } else if (realOffset === -210) {
    return -100;
  } else if (realOffset === -105) {
    return -21;
  } else if (realOffset === -94) {
    return -27;
  } else if (realOffset === -56) {
    return -205;
  } else if (realOffset === -106) {
    return -41;
  } else {
    return realOffset;
  }
};
export const replaceCardsPerPage = (cardsPerPage: number): number => {
  if (cardsPerPage === 2) {
    return 4;
  }
  if (cardsPerPage === 3) {
    if (window.innerWidth >= 840 && window.innerWidth < 900) {
      return 4;
    } else if (window.innerWidth >= 900 && window.innerWidth < 1280) {
      return 5;
    }
  }
  if (cardsPerPage === 4) {
    if (window.innerWidth >= 768 && window.innerWidth < 840) {
      return 2;
    } else if (window.innerWidth >= 840 && window.innerWidth < 900) {
      return 3;
    }
  }
  if (cardsPerPage === 5) {
    if (window.innerWidth >= 900 && window.innerWidth < 1280) {
      return 3;
    } else if (window.innerWidth >= 1280 && window.innerWidth < 1440) {
      return 6;
    } else if (window.innerWidth >= 1440) {
      return 7;
    }
  }
  if (cardsPerPage === 6 || cardsPerPage === 7) {
    return 5;
  } 
  return cardsPerPage;
};
/* export const replaceCardsPerPage = (currentCardsPerPage: number): number => {
  const screenWidth = window.innerWidth;

  if (currentCardsPerPage === 2) {
    return screenWidth >= 840 ? 4 : 2;
  }

  if (currentCardsPerPage === 3) {
    if (screenWidth >= 900 && screenWidth < 1280) {
      return 5;
    }

    if (screenWidth >= 1280) {
      return 6;
    }
  }

  if (currentCardsPerPage === 4) {
    if (screenWidth >= 768 && screenWidth < 840) {
      return 2;
    }

    if (screenWidth >= 840 && screenWidth < 900) {
      return 3;
    }
  }

  if (currentCardsPerPage === 5) {
    if (screenWidth >= 900 && screenWidth < 1280) {
      return 3;
    }

    if (screenWidth >= 1280 && screenWidth < 1440) {
      return 6;
    }

    if (screenWidth >= 1440) {
      return 7;
    }
  }

  if (currentCardsPerPage === 6 || currentCardsPerPage === 7) {
    return 5;
  }

  return currentCardsPerPage;
}; */

export const enablePrevIcon = (event: React.MouseEvent<HTMLElement> | HTMLElement) => {
  let prevIcon: HTMLButtonElement;

  if (event instanceof HTMLElement) {
    prevIcon = event.parentElement?.querySelector(".prevButton") as HTMLButtonElement;
  } else {
    prevIcon = event.currentTarget.parentElement?.querySelector(".prevButton") as HTMLButtonElement;
  }

  if (prevIcon) {
    prevIcon.disabled = false;
    prevIcon.classList.remove("Mui-disabled");
    prevIcon.innerHTML = '<img src="' + PrevIconEnabled + '">';
  }
};
export const disablePrevIcon = (event: React.MouseEvent<HTMLElement> | HTMLElement) => {
  let prevIcon: HTMLButtonElement;

  if (event instanceof HTMLElement) {
    prevIcon = event.parentElement?.querySelector(".prevButton") as HTMLButtonElement;
  } else {
    prevIcon = event.currentTarget.parentElement?.querySelector(".prevButton") as HTMLButtonElement;
  }
  if (prevIcon) {
    prevIcon.disabled = true;
    prevIcon.classList.add("Mui-disabled");
    prevIcon.innerHTML = '<img src="' + PrevIconDisabled + '">';
  }
};
export const enableNextIcon = (event: React.MouseEvent<HTMLElement> | HTMLElement) => {
  let nextIcon: HTMLButtonElement;

  if (event instanceof HTMLElement) {
    nextIcon = event.parentElement?.querySelector(".nextButton") as HTMLButtonElement;
  } else {
    nextIcon = event.currentTarget.parentElement?.querySelector(".nextButton") as HTMLButtonElement;
  }

  if (nextIcon) {
    nextIcon.disabled = false;
    nextIcon.classList.remove("Mui-disabled");
    nextIcon.innerHTML = '<img src="' + NextIconEnabled + '">';
  }
};
export const disableNextIcon = (event: React.MouseEvent<HTMLElement> | HTMLElement) => {
  let nextIcon: HTMLButtonElement;

  if (event instanceof HTMLElement) {
    nextIcon = event.parentElement?.querySelector(".nextButton") as HTMLButtonElement;
  } else {
    nextIcon = event.currentTarget.parentElement?.querySelector(".nextButton") as HTMLButtonElement;
  }

  if (nextIcon) {
    nextIcon.disabled = true;
    nextIcon.classList.add("Mui-disabled");
    nextIcon.innerHTML = '<img src="' + NextIconDisabled + '">';
  }
};

export const removeHoverPointer = (element: HTMLElement | null) => {
  if (element && element.classList.contains("hoverPointer")) {
    element.classList.remove("hoverPointer");
  }
};
export const addHoverPointer = (element: HTMLElement | null) => {
  if (element && !element.classList.contains("hoverPointer")) {
    element.classList.add("hoverPointer");
  }
};
